<rt-dialog-header [heading]="heading()" [subheading]="subheading()" />

<rt-dialog-body>
  @if (!isLoaded()) {
    <rt-box variant="vertical">
      <rt-spinner />
    </rt-box>
  }
  @if (isLoaded()) {
    <rt-box variant="vertical background no-padding">
      <div #results class="results">
        @for (container of containers(); track trackByContainer($index, container)) {
          <div class="result">
            <rt-group
              variant="horizontal"
              [class.checked]="isSelected(container)"
              (click)="toggleAssignment(container)"
            >
              <rt-checkbox
                [checked]="isSelected(container)"
                (click)="toggleAssignment(container)"
              />
              <div class="title-wrap" margin-left-small>
                <rt-heading>{{ containerName(container) }}</rt-heading>
                <span>
                  <rt-date [time]="container.createdAt" />
                </span>
              </div>
            </rt-group>
            <rt-divider />
          </div>
        }
      </div>
      @if (!results.children.length) {
        <rt-empty-state
          variant="small"
          [icon]="'search'"
          [title]="'app.common.no_results_found' | translate"
        />
      }
    </rt-box>
  }
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button variant="plain" [disabled]="!isLoaded()" (click)="cancel()" margin-right-small>
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button
    variant="primary"
    [disabled]="(newAssignments?.length === 0 && disableSubmitIfNoAssignments()) || !isLoaded()"
    [loading]="isLoading()"
    (click)="submit()"
  >
    {{ submitText() || ('app.common.save' | translate) }}
  </rt-button>
</rt-dialog-footer>
